'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
require('../../themes/alert.js');
var borders = require('../../themes/borders.js');
require('../../themes/button.js');
require('../../themes/checkbox.js');
require('../../themes/divider.js');
require('../../themes/dropdown.js');
require('../../themes/fieldset.js');
require('../../themes/input.js');
require('../../themes/list.js');
require('../../themes/listbox.js');
require('../../themes/loader.js');
require('../../themes/option.js');
require('../../themes/popout.js');
require('../../themes/switch.js');
require('../../themes/themes.js');
require('../../themes/tooltip.js');

const baseListStyle = styled.css`
  border-radius: ${borders.borderRadiusLarge}px;
  border-color: transparent;
  border-style: solid;
  display: block;
  list-style: none;
  margin: 0;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 1;
`;
/**
 * Get Styled Component virtualized CSS styles
 * @param options GetListVirtualizedCssOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getListVirtualizedCss = (options)=>{
    const { borderWidth , height , padding  } = options;
    return styled.css`
    border-width: ${borderWidth}px;
    max-height: ${height}px;
    padding: ${padding}px;
  `;
};
/**
 * Get Styled Component list theme
 * @param options GetListThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getListTheme = (options)=>{
    const { look  } = options;
    return styled.css`
    background-color: ${({ theme  })=>theme.list[look].backgroundColor};
    border-color: ${({ theme  })=>theme.list[look].borderColor};
  `;
};

exports.baseListStyle = baseListStyle;
exports.getListTheme = getListTheme;
exports.getListVirtualizedCss = getListVirtualizedCss;
//# sourceMappingURL=list.js.map
